import { DateString } from "../api/models";

export const dateLimitation: DateString = "1987-01-01";
